export default __webpack_public_path__ + "static/media/icon-facebook-w.885a5054.svg";